/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";

const API = process.env.NEXT_PUBLIC_API_URL;

export default function BlogPage() {
  const [blogs, setBlogs] = useState<any[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/v1/blog`);
        const data = await res.json();
        if (data.success && Array.isArray(data.data)) {
          const published = data.data.filter((b: any) => b.status === "published");
          setBlogs(published);
        }
      } catch (err) {
        console.error("Failed to load blogs:", err);
      }
    })();
  }, []);

  const filteredBlogs = blogs.filter((b) =>
    b.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <section className="min-h-screen bg-[#f9f9f9] py-14 sm:py-20 px-4 sm:px-8">
      {/* === Top Bar === */}
      <div className="max-w-6xl mx-auto flex justify-between items-center mb-10 sm:mb-14">
        <Link
          href="/"
          className="flex items-center gap-2 text-[#4177BC] font-medium text-sm sm:text-base hover:text-[#275b93] transition-all duration-300"
        >
          <FaArrowLeftLong className="text-base sm:text-lg" />
          <span>Back to Home</span>
        </Link>

        <span className="hidden sm:block text-gray-400 text-sm">
          {filteredBlogs.length} Articles
        </span>
      </div>

      {/* === Header === */}
      <div className="mx-auto container text-center mb-12 sm:mb-16">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#111] mb-3 tracking-tight">
          Insights & Guides
        </h1>
        <p className="text-gray-500 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
          Stay informed with expert advice, market updates, and practical tips
          to make smarter real estate decisions.
        </p>
      </div>

      {/* === Search Bar === */}
      <div className="max-w-3xl mx-auto mb-14">
        <div className="flex items-center bg-white border border-gray-200 rounded-full px-5 py-3 shadow-sm focus-within:ring-2 focus-within:ring-[#4177BC] transition">
          <FaSearch className="text-gray-500 text-sm mr-3" />
          <input
            type="text"
            placeholder="Search articles..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="flex-1 outline-none bg-transparent text-sm sm:text-base text-[#333] placeholder-gray-400"
          />
        </div>
      </div>

      {/* === Blog Cards === */}
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {filteredBlogs.length > 0 ? (
          filteredBlogs.map((post) => (
            <Link
              key={post._id}
              href={`/blogs/${post._id}`}
              className="group relative block w-full h-[420px] sm:h-[480px] rounded-3xl overflow-hidden bg-gray-200 shadow-sm hover:shadow-lg transition-all duration-500"
            >
              {/* ✅ Normal image tag */}
              <img
                src={
                  post.heroUrl?.startsWith("http")
                    ? post.heroUrl
                    : "/placeholder.jpg"
                }
                alt={post.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />

              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-linear-to-t from-black/70 via-black/30 to-transparent transition-opacity duration-500 group-hover:from-black/80"></div>

              {/* Text content overlay */}
              <div className="absolute bottom-0 left-0 p-6 sm:p-8 text-white z-10">
                <p className="text-sm text-gray-300 mb-2">
                  {new Date(post.createdAt).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </p>
                <h3 className="text-2xl sm:text-3xl font-semibold leading-snug mb-2">
                  {post.title}
                </h3>
                <p className="text-sm text-gray-200 max-w-md line-clamp-2">
                  {post.description}
                </p>
                <div className="mt-4 inline-block bg-white text-black font-medium text-sm px-5 py-2 rounded-full group-hover:bg-[#4177BC] group-hover:text-white transition-all duration-300">
                  Read More
                </div>
              </div>
            </Link>
          ))
        ) : (
          <p className="text-center text-gray-500 col-span-full">
            No articles found.
          </p>
        )}
      </div>
    </section>
  );
}
